import OBase from './OBase';
import * as Geometry from '../geometry';
import * as Component from '../components';
import * as GHMath from '../../math';
// import * as GHMath from '../../math'

export default class EFabFillet extends OBase {
  update () {
    let srfTree = this.getSurfaceObjectInput('surface');
    let ftTree = this.getFloatInput('filletType');
    let millTree = this.getFloatInput('mill');
    let angleTree = this.getFloatInput('angle');
    let filletOutput = this.getGenericObjectOutput('fillet');
    let segments = 36;

    var dataTrees = [];
    var outDataTrees = [];
    dataTrees.push(srfTree);
    dataTrees.push(ftTree);
    dataTrees.push(millTree);
    dataTrees.push(angleTree);
    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let outTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let paths = outDataTrees[0].branches[i][j];
        let filletType = outDataTrees[1].branches[i][j];
        let mill = outDataTrees[2].branches[i][j];
        let angle = outDataTrees[3].branches[i][j];
        let filletPosition = this.getFilletPosition(paths, angle);
        let polygons = this.makeOutlineWithFillet(paths, filletPosition, mill, segments, filletType);
        outTree.add(polygons, outDataTrees[0].paths[i]);

        /*
        if (!this.ghGeometryObject.hidden) {
          polygons.forEach(el => {
            global.debugger.debugClipper(el)
          })
        }
        */
      }
    }

    filletOutput.value = outTree;
  }

  checkAngle (aVec, bVec) {
    let absAVec = Math.sqrt(Math.pow(aVec.X, 2) + Math.pow(aVec.Y, 2));
    let absBVec = Math.sqrt(Math.pow(bVec.X, 2) + Math.pow(bVec.Y, 2));
    let dot = this.dotProduct(aVec, bVec);
    let theta = Math.acos(dot / (absAVec * absBVec)) * 180.0 / Math.PI;
    return theta;
  }

  dotProduct (aVec, bVec) {
    let dot = aVec.X * bVec.X + aVec.Y * bVec.Y;
    return dot;
  }

  crossProduct (aVec, bVec) {
    var cross = aVec.X * bVec.Y - aVec.Y * bVec.X;
    return cross;
  }

  pt2vecFlow (pt0, pt1, pt2) {
    let aVec = {'X': pt1.X - pt0.X, 'Y': pt1.Y - pt0.Y};
    let bVec = {'X': pt2.X - pt1.X, 'Y': pt2.Y - pt1.Y};
    return [aVec, bVec];
  }

  pt2vecAngle (pt0, pt1, pt2) {
    let aVec = {'X': pt1.X - pt0.X, 'Y': pt1.Y - pt0.Y};
    let bVec = {'X': pt2.X - pt0.X, 'Y': pt2.Y - pt0.Y};
    return [aVec, bVec];
  }

  pointsEqual(pt1, pt2) {
    return pt1.X === pt2.X && pt1.Y === pt2.Y;
  }

  getInexList (pointsList) {
    var inexList = [];
    for (let i = 0; i < pointsList.length; i++) {
      if (i === 0) {
        inexList.push(0);
      } else {
        inexList.push(1);
      }
    }
    return inexList;
  }

  getFilletPosition (pointsList, angleThresh) {
    var inexList = this.getInexList(pointsList);

    var filletPosition = [];
    for (let i = 0; i < pointsList.length; i++) {
      // オブジェクトの数
      var fillets = [];
      let lineInex = inexList[i];

      // 時計回りor反時計回りの判定
      let crossClockwise = -1;
      if (i === 0) {
        crossClockwise = 1;
      } else {
        crossClockwise = -1;
      }

      // clockwise anticlockwise checker

      // 出隅入隅の判定
      const K = pointsList[i].length;
      for (let k = 0; k < K; k++) {
        var flowVec, angVec;
        if (k === 0) { // || k === K - 1) {
          const d = this.pointsEqual(pointsList[i][0], pointsList[i][K - 1]) ? 2 : 1;
          flowVec = this.pt2vecFlow(
            pointsList[i][K - d],
            pointsList[i][0],
            pointsList[i][1]
          );
          angVec = this.pt2vecAngle(
            pointsList[i][0],
            pointsList[i][K - d],
            pointsList[i][1]
          );
        } else if (k > 0 && k !== K - 1) {
          flowVec = this.pt2vecFlow(
            pointsList[i][k - 1],
            pointsList[i][k],
            pointsList[i][(k + 1) % K]
          );
          angVec = this.pt2vecAngle(
            pointsList[i][k],
            pointsList[i][k - 1],
            pointsList[i][(k + 1) % K]
          );
        }

        let crossCorner = this.crossProduct(flowVec[0], flowVec[1]);
        // dezumi irizumi checker

        // 角度の判定
        var comment = 'no fillet';
        var filletAddition = false;
        let angle = this.checkAngle(angVec[0], angVec[1]);

        if (angle > 10 && angle < (angleThresh / Math.PI * 180.0)) {
          // 角度によってフィレットつけるか判断
          // フィレットを作成
          if (crossClockwise > 0) {
            // Anticlockwise
            if (crossCorner > 0) {
              if (lineInex === 1 || lineInex === 2) {
                comment = 'Anticlockwise / internal lines / dezumi --> fillet';
                filletAddition = true;
              } else {
                filletAddition = false;
              }
            } else if (crossCorner < 0) {
              if (lineInex === 0) {
                comment = 'Anticlockwise / external lines / irizumi --> fillet';
                filletAddition = true;
              } else {
                filletAddition = false;
              }
            } else {
              filletAddition = false;
            }
          } else if (crossClockwise < 0) {
            // clockwise
            if (crossCorner > 0) {
              if (lineInex === 0) {
                comment = 'clockwise / external lines / irizumi --> fillet';
                filletAddition = true;
              } else {
                filletAddition = false;
              }
            } else if (crossCorner < 0) {
              if (lineInex === 1) {
                comment = 'clockwise / internal lines / dezumi --> fillet';
                filletAddition = true;
              } else {
                filletAddition = false;
              }
            } else {
              filletAddition = false;
            }
          } else if (crossClockwise === 0) {
            filletAddition = false;
          }

          if (filletAddition) {
            // console.log(comment)
            fillets.push(k);
          }
        }
      }
      filletPosition.push(fillets);
    }

    return filletPosition;
  }

  tboneH (pointsList, i, ptIndex, mill) {
    var coord;
    if (ptIndex % 2 === 0) {
      coord = this.tboneA(pointsList, i, ptIndex, mill);
    } else if (ptIndex % 2 === 1) {
      coord = this.tboneB(pointsList, i, ptIndex, mill);
    }
    return coord;
  }

  tboneI (pointsList, i, ptIndex, mill) {
    var coord;
    if (ptIndex % 2 === 0) {
      coord = this.tboneB(pointsList, i, ptIndex, mill);
    } else if (ptIndex % 2 === 1) {
      coord = this.tboneA(pointsList, i, ptIndex, mill);
    }
    return coord;
  }

  oldDogbone (pointsList, i, ptIndex) {
    var point = pointsList[i][ptIndex];
    return point;
  }

  dogbone (pointsList, i, ptIndex, mill) {
    let oIndex = ptIndex;
    let oPt = new THREE.Vector3(pointsList[i][ptIndex].X, pointsList[i][ptIndex].Y, 0);
    var aPt, bPt;

    let index1 = ptIndex - 1;
    if (index1 < 0) { index1 = pointsList[i].length - 1; }
    let index2 = (ptIndex + 1) % pointsList[i].length;
    aPt = new THREE.Vector3(pointsList[i][index1].X, pointsList[i][index1].Y, 0);
    bPt = new THREE.Vector3(pointsList[i][index2].X, pointsList[i][index2].Y, 0);

    let aVec = aPt.sub(oPt);
    aVec.normalize();
    let bVec = bPt.sub(oPt);
    bVec.normalize();

    let aAbs = Math.sqrt(Math.pow(aVec.x, 2) + Math.pow(aVec.y, 2) + Math.pow(aVec.z, 2));
    let bAbs = Math.sqrt(Math.pow(bVec.x, 2) + Math.pow(bVec.y, 2) + Math.pow(bVec.z, 2));
    let newX = bAbs / (aAbs + bAbs) * aVec.x + aAbs / (aAbs + bAbs) * bVec.x;
    let newY = bAbs / (aAbs + bAbs) * aVec.y + aAbs / (aAbs + bAbs) * bVec.y;

    let newVec = new THREE.Vector3(newX, newY, 0);
    newVec.normalize();

    newX = oPt.x + newVec.x * (mill / 2);
    newY = oPt.y + newVec.y * (mill / 2);
    let center = [newX, newY, 0];

    return center;
  }

  makeOutlineWithFillet (pointsList, filletPosition, mill, segments, filletType) {
    if (pointsList.length <= 0) return [];

    let inexList = this.getInexList(pointsList);
    let polygons = [];

    let exterior = [pointsList[0]]; // []
    let interiors = [];
    for (let i = 0; i < filletPosition.length; i++) {
      let originalPolyline = [pointsList[i]];

      // if (filletPosition[i].length === 0) {
      //   exterior = originalPolyline.slice()
      // } else

      var surface = originalPolyline.slice();
      interiors.push(surface);
      if (filletPosition[i].length > 0) {
        for (let j = 0; j < filletPosition[i].length; j++) {
          let ptIndex = filletPosition[i][j];
          var coord;
          if (filletType === 2) {
            coord = this.tboneA(pointsList, i, ptIndex, mill);
          } else if (filletType === 1) {
            coord = this.tboneB(pointsList, i, ptIndex, mill);
          } else if (filletType === 4) {
            coord = this.tboneH(pointsList, i, ptIndex, mill);
          } else if (filletType === 3) {
            coord = this.tboneI(pointsList, i, ptIndex, mill);
          } else {
            coord = this.dogbone(pointsList, i, ptIndex, mill);
          }

          let point = new THREE.Vector3(coord[0], coord[1], coord[2]);
          let circleCrv = Component.ECircle.createCircle(point, mill / 2.0, segments);
          circleCrv = Component.Rotate.TransformRotate(circleCrv,
            new GHMath.GHPlane(point, new THREE.Vector3(1, 0, 0), new THREE.Vector3(0, 1, 0)),
            0.123456789 / 180.0 * Math.PI
          );

          let newRegion;

          if (inexList[i] === 0) {
            newRegion = Component.EDifference.createDifference(surface, [circleCrv]);
          } else if (inexList[i] === 1) {
            newRegion = Component.EUnion.createUnion([surface, circleCrv]);
          }
          interiors.push(circleCrv);
          surface = newRegion;
        }
      }

      let crv = surface;
      if (inexList[i] === 0) {
        exterior = crv;
      } else {
        for (let m = 0; m < crv.length; m++) {
          polygons.push(crv[m]);
        }
      }
    }

    let differenced;
    if (pointsList.length > 1) { // (exterior.length > 0) {
      differenced = Component.EDifference.createDifference(exterior, [polygons]);
    } else {
      differenced = exterior;
    }

    return differenced;
  }

  tboneA (pointsList, i, ptIndex, mill) {
    let oIndex = ptIndex;
    let oPt = new THREE.Vector3(pointsList[i][ptIndex].X, pointsList[i][ptIndex].Y, 0);
    var aPt;
    if (oIndex === 0) {
      aPt = new THREE.Vector3(pointsList[i][pointsList[i].length - 1].X, pointsList[i][pointsList[i].length - 1].Y, 0);
    } else if (oIndex === pointsList[i].length - 1) {
      aPt = new THREE.Vector3(pointsList[i][ptIndex - 1].X, pointsList[i][ptIndex - 1].Y, 0);
    } else {
      aPt = new THREE.Vector3(pointsList[i][ptIndex - 1].X, pointsList[i][ptIndex - 1].Y, 0);
    }
    let aVec = aPt.sub(oPt);
    aVec.normalize();

    let newX = oPt.x + aVec.x * (mill / 2);
    let newY = oPt.y + aVec.y * (mill / 2);
    let center = [newX, newY, 0];
    return center;
  }

  tboneB (pointsList, i, ptIndex, mill) {
    let oIndex = ptIndex;
    let oPt = new THREE.Vector3(pointsList[i][ptIndex].X, pointsList[i][ptIndex].Y, 0);
    var bPt;
    if (oIndex === 0) {
      bPt = new THREE.Vector3(pointsList[i][ptIndex + 1].X, pointsList[i][ptIndex + 1].Y, 0);
    } else if (oIndex === pointsList[i].length - 1) {
      bPt = new THREE.Vector3(pointsList[i][0].X, pointsList[i][0].Y, 0);
    } else {
      bPt = new THREE.Vector3(pointsList[i][ptIndex + 1].X, pointsList[i][ptIndex + 1].Y, 0);
    }
    let bVec = bPt.sub(oPt);
    bVec.normalize();

    let newX = oPt.x + bVec.x * (mill / 2);
    let newY = oPt.y + bVec.y * (mill / 2);
    let center = [newX, newY, 0];

    return center;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/EFabFillet.js